import axios from "axios";

// DOMA CUSTOMER START
export async function requestGetDOMACustomerList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/@doma/customers?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestAddDOMACustomer(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/@doma/customers/add`, payload);
}
// DOMA CUSTOMER END
